import React from 'react';

import productFrontSide from '../../../main/assets/images/lapRf/immersionrc-lap-rf-front-side.webp';

export const About = () => {
  return (
    <section className="laprf-about">
      <img
        src={productFrontSide}
        alt="Close-Up View of the Device"
        className="laprf-about-product"
      />
      <div className="laprf-about-text-container">
        <div className="laprf-about-text-section">
          <h3 className="laprf-about-text-title">
            Advanced Timing & Detection
          </h3>
          <p className="laprf-about-text-description">
            Orqa’s custom receiver adapts to power levels and filters
            interference. Gate-shaped antennas offer accurate detection across
            RHCP, LHCP, and linear polarization.
          </p>
        </div>
        <div className="laprf-about-text-section">
          <h3 className="laprf-about-text-title">
            Seamless Integration & Resilience
          </h3>
          <p className="laprf-about-text-description">
            With Ethernet connectivity, IP67 waterproofing, and passive cooling,
            LapRF is built for easy integration, harsh conditions, and high
            performance.
          </p>
        </div>
        <div className="laprf-about-text-section">
          <h3 className="laprf-about-text-title">LiveTime Support</h3>
          <p className="laprf-about-text-description">
            Compatible with LiveTime via USB/Ethernet, LapRF 8-Way features
            auto-calibration and a spectrum analyzer.
          </p>
        </div>
      </div>
    </section>
  );
};
